import React  from "react";
import { useParams } from 'react-router-dom';
import EmployeeForm from "./components/EmployeeDetails";

const EditEmployee = () => {
	const { employeeId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<EmployeeForm recordId={employeeId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditEmployee;